import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

export type SafeContentType = 'html' | 'url' | 'urlResource';

@Pipe({
  name: 'safeContent'
})
export class SafeContentPipe implements PipeTransform {

  constructor(private readonly sanitized: DomSanitizer) {}

  transform(value: string, type: SafeContentType): SafeHtml | SafeResourceUrl | SafeUrl {
    switch (type) {
      case 'html':
        return this.sanitized.bypassSecurityTrustHtml(value);
      case 'urlResource':
        return this.sanitized.bypassSecurityTrustResourceUrl(value);
      case 'url':
        return this.sanitized.bypassSecurityTrustUrl(value);
      default:
        throw new Error(`Invalid type specified: ${type}`);
    }
  }
}
